<script>
export default {
    name: "base-switch",
    props: {
        value: [Array, Boolean, Number],
        type: String,
        onText: {
            type: String,
            default: "",
        },
        offText: {
            type: String,
            default: "",
        },
        disabled: {
            default: false,
        },
        useNumeric: {
            type: Boolean,
            default: false,
            description: "Use booleans as v-model or 1/0 if true"
        }
    },
    computed: {
        switchClass() {
            let baseClass = "custom-toggle-";
            if (this.type) {
                return baseClass + this.type;
            }
            return "";
        },
        model: {
            get() {
                return this.value;
            },
            set(value) {
                if (value) {
                    this.$emit("input", 1);
                } else {
                    this.$emit("input", 0);
                }
            },
        },
    },
    methods: {
        triggerToggle() {
            this.model = !this.model;
        },
    },
};
</script>

<template>
    <label class="custom-toggle" :class="switchClass">
        <input type="checkbox" v-model="model" :disabled="disabled" />
        <span
            class="custom-toggle-slider rounded-circle"
            :data-label-off="offText"
            :data-label-on="onText"
        >
        </span>
    </label>
</template>

<style></style>
